import axios from 'axios'
import qs from 'qs'
import { ElNotification } from 'element-plus'
import { getSession, clearSession } from './common'
import { BASE_URL } from './url'
import router from '@/router/index.js'
import * as Api from '@/api/account.js'
import storage from '@/modules/storage.js'

// let version = null
function createInstance() {
  const instance = axios.create({
    baseURL: BASE_URL
  })
  instance.interceptors.request.use(async (request) => {

    // 设置tenant_id 和 authorization
    request.baseURL = BASE_URL
    let session = getSession()
    if (session) {
      if (session?.id) {
        request.headers['TENANT-ID'] = getSession().id
      }
      if (session?.['access_token']) {
        request.headers['authorization'] = `${session['token_type']} ${session['access_token']}`
      }
    }

    let url = request.url.indexOf('?') > 0 ? request.url.slice(0, request.url.indexOf('?')) : request.url
    // 判断Authorization
    let LoginAuthorizationArr = [
      '/auth/oauth2/by-password',
      '/code/create',
      '/code/check',
      '/auth/oauth2/sms',
      '/auth/oauth2/validate-sms',
      '/auth/token/check_token',
      '/auth/token/logout',
      '/auth/oauth2/token'
    ]
    if (LoginAuthorizationArr.join().indexOf(url) >= 0) {
      request.headers['authorization'] = 'basic dGVuYW50OnRlbmFudA=='
    }
    // 判断前缀
    let LoginBaseArr = [
      '/auth/oauth2/by-password',
      '/code/create',
      '/code/check',
      '/auth/oauth2/sms',
      '/auth/oauth2/validate-sms',
      '/auth/token/check_token',
      '/auth/token/logout',
      '/auth/oauth2/token',
      '/auth/token/authenticated' // 权限
    ]
    if (request.url.split('/')?.[1] === 'flow') {
      request.baseURL = BASE_URL
    } else if (!(LoginBaseArr.join().indexOf(url) >= 0 || request.url.indexOf('/message') >= 0)) {
      request.baseURL = BASE_URL + '/business'
    }
    // 开发环境默认使用固定的登录URL
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === 'development' && LoginBaseArr.join().indexOf(url) >= 0) {
      // request.baseURL = 'http://192.167.6.41:7102/api-v2'
      request.baseURL = 'http://192.167.6.153:19000'
    }
    // 判断短信登录的Authorization
    let MobileAuthorization = 'auth/oauth2/token'
    if (url.indexOf(MobileAuthorization) >= 0) {
      const params = qs.parse(request.url.split('?')[1])
      if (params.grant_type === 'mobile') {
        request.headers['authorization'] = 'basic dGVuYW50X21vYmlsZTp0ZW5hbnRfbW9iaWxlX3NlY3JldF94eHh4'
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      }
    }
    // 处理get参数转换
    if (request.method === 'get') {
      // 如果是get请求，且参数为对象，则转换对象
      let query = qs.stringify(request.params, { indices: false })
      request.params = {}
      request.url += query ? `?${query}` : ''
    }

    return request
  })

  instance.interceptors.response.use(
    async (response) => {
      return await transformResponseData(response)
    },
    async (error) => {
      return await handleResponseError(error, instance)
    }
  )
  return instance
}

async function transformResponseData(response) {
  if (response.data.code === 0 || response.data.code === 200) {
    return response.data.data || response.data
  } else if (response.data['access_token'] || response.data.active) {
    // 登录等特殊接口
    return response.data
  } else if (response.config.url.indexOf('sys-file/download') >= 0 || response.config.url.indexOf('security-accrued/export') >= 0 || response.config.url.indexOf('enterprise-user/download/template') >= 0 || response.config.url.indexOf('/safe-procedures/export') >= 0 || response.config.url.indexOf('/safe-procedures/download/template') >= 0 || response.config.url.indexOf('/check-standard/download/temp-file') >= 0) {
    // 下载特殊处理
    return response.data
  } else if (response.config.url.indexOf('auth/token/authenticated') >= 0 && response.data.code === 1) {
    // 无权限特殊处理
    await ElNotification({ title: '错误提示', message: '账号无权限，请联系管理员', duration: 10000 })
    await router.push({ name: 'login' })
    clearSession()
  } else {
    await ElNotification({ title: '错误提示', message: response.data.msg, duration: 10000 })
    return response.data
  }
}

// 刷新token
let isRefreshing = false
//重试队列
let requests = []

async function refreshHandler(error, instance) {
  let msg = error.response?.data?.msg || error.response?.data || ''
  // 如果本地没有refresh_token直接重新登陆
  if (!getSession().refresh_token) {
    await runUnauthorizedHandler(msg)
    return Promise.reject(false)
  }
  // 如果是下面的刷新token接口报错 会进到下面catch里面
  if (error.config.url.split('?')[0] === '/auth/oauth2/token') {
    return Promise.reject(false)
  }
  if (!isRefreshing) {
    try {
      isRefreshing = true
      let params = {
        grant_type: 'refresh_token',
        refresh_token: getSession().refresh_token
      }
      let session = await Api.login(params)
      if (session['access_token']) {
        const token = session['access_token']
        let local = storage.get('session')
        storage.set('session', { ...local, ...session })

        error.config.headers['authorization'] = `${getSession()['token_type']} ${token}`
        requests.forEach((cb) => cb(token))
        return instance(error.config)
      } else {
        await runUnauthorizedHandler(msg)
        return Promise.reject(false)
      }
    } catch (e) {
      await runUnauthorizedHandler(msg)
    } finally {
      requests = []
      isRefreshing = false
    }
  } else {
    return new Promise(resolve => {
      requests.push(token => {
        error.config.headers['authorization'] = `${getSession()['token_type']} ${token}`
        resolve(instance(error.config))
      })
    })
  }
}

let unauthorizedHandlerRunning = false

async function runUnauthorizedHandler(msg = null) {
  if (unauthorizedHandlerRunning) return
  unauthorizedHandlerRunning = true
  await ElNotification({ title: '错误提示', message: msg ? msg : '登录状态已过期，请重新登录', duration: 10000 })
  unauthorizedHandlerRunning = false
  await router.push({ name: 'login' })
  clearSession()
}

async function handleResponseError(error, instance) {
  let msg = error.response?.data?.msg || error.response?.data || ''
  console.log('msg', msg)
  if (error.response?.status === 400) {
    await ElNotification({ title: '错误提示', message: msg || '认证失败！', duration: 10000 })
  } else if (error.response?.status === 401) {
    return await runUnauthorizedHandler(msg)
  } else if (error.response.status === 424) {
    return await refreshHandler(error, instance)
  } else if (error.response.status === 403) {
    await ElNotification({ title: '错误提示', message: '禁止访问！', duration: 10000 })
    return Promise.reject(false)
  } else if (error.response.status === 500) {
    await ElNotification({ title: '错误提示', message: '服务异常！', duration: 10000 })
    return Promise.reject(false)
  } else {
    await ElNotification({
      title: '错误提示',
      message: `${msg ? msg : '服务器错误！错误码：' + error.response.status || ''}`,
      duration: 10000
    })
    return Promise.reject(false)
  }
}

export default createInstance()
